import { debug } from 'debug';

/**
 * 排查「checkFormSettings / getPopupConfig 之后未弹窗」全链路。
 *
 * 控制台启用：
 *   localStorage.debug = 'cartx:popup-flow'
 * 可选一并打开策略日志：
 *   localStorage.debug = 'cartx:popup-flow,cartsee:logic,cartsee:priority'
 * 然后刷新页面。
 *
 * 说明：type=0 走「多订阅 triggerPop0s」时，配置往往由 showFromTriggerList 回调 getResponse 渲染，
 * getPopupConfig 的 Promise 可能不会走到 resolve/reject，请以带 load/show/match 前缀的日志为准。
 *
 * 离开意图（mouseleave / leaveBeta / H5 onpopstate）也统一走本 logger，消息里含 triggerLeaveLoad、mouseleave 等关键字。
 */
export const popupFlowLog = debug('cartx:popup-flow');
